import { FullscreenOverlayContainer, OverlayContainer } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { PIconModule } from '@panaya/ui/p-icon';
import { PipeModule } from '@panaya/ui/pipes';
import { PButtonModule } from '@panaya/ui/p-button';
import { PFieldModule } from '../p-field';
import { PKeyValueViewerModule } from '../p-key-value-viewer';
import { PLoadingModule } from '../p-loading';
import { PSnackbarModule } from '../p-snackbar-toaster';
import { EditLinkDialogComponent } from './edit-link-dialog.component';
import { PDialogContainerComponent } from './p-dialog-container/p-dialog-container.component';
import { PDialogFooterComponent } from './p-dialog-footer.component';
import { PDialogHeaderComponent } from './p-dialog-header.component';
import { PErrorDialogComponent } from './p-error-dialog.component';
import { PInfoDialogComponent } from './p-info-dialog/p-info-dialog.component';
import { PKeyValueSensitiveConvertor, PKeyValueViewerDialogComponent } from './p-key-value-viewer-dialog';
import { POkCancelDialogComponent } from './p-ok-cancel-dialog.component';
import { PWarningWithActionDialogComponent } from './p-warning-with-action-dialog.component';
import { PDialogComponent } from './p-dialog.component';
import { PConfirmWithCommentDialogComponent } from './p-confirm-with-comment-dialog/p-confirm-with-comment-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PTooltipModule } from '@panaya/ui/p-tooltip';
import { PEmptyStateDialogComponent } from './p-empty-state-dialog/p-empty-state-dialog.component';
import { EmptyStateComponent } from '../empty-state';
import { PFeedbackDialogComponent } from './p-feedback-dialog/p-feedback-dialog.component';

@NgModule({
    providers: [{ provide: OverlayContainer, useClass: FullscreenOverlayContainer }],
    declarations: [
        PDialogContainerComponent,
        PInfoDialogComponent,
        EditLinkDialogComponent,
        PDialogFooterComponent,
        PDialogHeaderComponent,
        PErrorDialogComponent,
        POkCancelDialogComponent,
        PWarningWithActionDialogComponent,
        PKeyValueViewerDialogComponent,
        PDialogComponent,
        PConfirmWithCommentDialogComponent,
        PKeyValueSensitiveConvertor,
        PEmptyStateDialogComponent,
        PFeedbackDialogComponent
    ],
    exports: [
        PDialogContainerComponent,
        PInfoDialogComponent,
        EditLinkDialogComponent,
        PDialogFooterComponent,
        PDialogHeaderComponent,
        PErrorDialogComponent,
        POkCancelDialogComponent,
        PWarningWithActionDialogComponent,
        PKeyValueViewerDialogComponent,
        PConfirmWithCommentDialogComponent,
        PDialogComponent,
        PKeyValueSensitiveConvertor,
        PEmptyStateDialogComponent,
        PFeedbackDialogComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        PFieldModule,
        PButtonModule,
        PIconModule,
        MatDialogModule,
        PipeModule,
        PSnackbarModule,
        PLoadingModule,
        PKeyValueViewerModule,
        PTooltipModule,
        EmptyStateComponent,
        ReactiveFormsModule
    ]
})
export class PDialogModule {}
